<div class="message-wrapper">
  <img src="assets/img/dog.webp" alt="Picture of a dog">

  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>404</ion-card-subtitle>
      <ion-card-title>{{ 'not-found.title' | translate }}</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <p>{{ 'not-found.description' | translate }}</p>
      <ion-button [routerLink]="linkToHome$ | async">
        <ion-icon slot="icon-only" name="play-skip-back-outline"></ion-icon>&nbsp;
        {{ 'not-found.back-to-home' | translate }}
      </ion-button>
    </ion-card-content>
  </ion-card>
</div>